import React, { useEffect, useState } from "react";
import { NavigationItem } from "shared/components/navbar/NavigationItem";

const isOverflowing = (element: HTMLDivElement | null) => {
  if (!element) return false;

  return element.scrollWidth > element.clientWidth + 5;
};
const isDistanceBetweenLeftAndRightGreaterThan130 = (
  left: HTMLDivElement | null,
  right: HTMLDivElement | null,
) => {
  if (!left || !right) return false;
  const leftRect = left.getBoundingClientRect();
  const rightRect = right.getBoundingClientRect();
  const distance = rightRect.left - leftRect.right;
  return distance > 130;
};

export const useMoreButtonResponsive = (primaryNavItems: NavigationItem[]) => {
  const [paritioned, setParition] = useState<
    [NavigationItem[], NavigationItem[]]
  >([primaryNavItems, []]);

  useEffect(() => {
    const resize = () => {
      const isOverflow = isOverflowing(leftRef.current);
      if (isOverflow) {
        setParition((current) => {
          if (current[0].length === 0) return current;
          const visible = current[0].slice();
          const overflow = visible.pop();

          return [visible, [overflow!, ...current[1]]];
        });
      } else {
        setParition((current) => {
          if (
            current[1].length === 0 ||
            !isDistanceBetweenLeftAndRightGreaterThan130(
              leftRef.current,
              rightRef.current,
            )
          ) {
            return current;
          }

          const visible = current[0].slice();
          const overflow = current[1].slice();
          const item = overflow[0];
          visible.push(item);
          overflow.shift();
          return [visible, overflow];
        });
      }
    };
    window.addEventListener("resize", resize);
    resize();
    return () => {
      window.removeEventListener("resize", resize);
    };
  }, [primaryNavItems]);

  const leftRef = React.useRef<HTMLDivElement>(null);
  const rightRef = React.useRef<HTMLDivElement>(null);
  return {
    leftContainerRef: leftRef,
    rightContainerRef: rightRef,
    visibleItems: paritioned[0],
    overflowItems: paritioned[1],
  };
};
